// extracted by mini-css-extract-plugin
export var text = "Hero-module--text--Ke1tN";
export var heading = "Hero-module--heading--dsVqy";
export var content = "Hero-module--content--TZgAZ";
export var fakeGrid = "Hero-module--fakeGrid--KU6zJ";